
/**
 * 经销商用户
 */

// 公共方法
import { setStoreApiDate } from '../utils'

export default {
  state: {},
  mutations: {},
  getters: {},
  actions: {
    // 经销商用户列表
    async fetchBusinessUserList({ commit, getters }, params) {
      const { businessUserList } = getters.getHttps
      const { data } = await businessUserList(params)
      return setStoreApiDate(data, commit)
    },
    // 添加经销商
    async fetchInsertDealerUserMerge({ commit, getters }, params) {
      const { insertDealerUserMerge } = getters.getHttps
      const { data } = await insertDealerUserMerge(params)
      return setStoreApiDate(data, commit)
    },
    // 修改经销商
    async fetchUpdateDealerUserMerge({ commit, getters }, params) {
      const { updateDealerUserMerge } = getters.getHttps
      const { data } = await updateDealerUserMerge(params)
      return setStoreApiDate(data, commit)
    },
    // 更改经销商使用状态
    async fetchUpdateBatchDealerUserStatus({ commit, getters }, params) {
      const { updateBatchDealerUserStatus } = getters.getHttps
      const { data } = await updateBatchDealerUserStatus(params)
      return setStoreApiDate(data, commit)
    },
    // 更改经销商黑名单状态
    async fetchUpdateBatchDealerUserBlacklistStatus({ commit, getters }, params) {
      const { updateBatchDealerUserBlacklistStatus } = getters.getHttps
      const { data } = await updateBatchDealerUserBlacklistStatus(params)
      return setStoreApiDate(data, commit)
    },
    // 删除经销商
    async fetchDeleteDealerUserMerge({ commit, getters }, params) {
      const { deleteDealerUserMerge } = getters.getHttps
      const { data } = await deleteDealerUserMerge(params, true)
      return setStoreApiDate(data, commit)
    },
    // 重置密码
    async fetchResetDealerUserPassword({ commit, getters }, params) {
      const { resetDealerUserPassword } = getters.getHttps
      const { data } = await resetDealerUserPassword(params, true)
      return setStoreApiDate(data, commit)
    },
    // 解绑经销商
    async fetchUnbindDealerUserByDeviceId({ commit, getters }, params) {
      const { unbindDealerUserByDeviceId } = getters.getHttps
      const { data } = await unbindDealerUserByDeviceId(params, true)
      return setStoreApiDate(data, commit)
    },
    // 查询经销商详情信息
    async fetchSelectDealerUserMerge({ commit, getters }, params) {
      const { selectDealerUserMerge } = getters.getHttps
      const { data } = await selectDealerUserMerge(params)
      return setStoreApiDate(data, commit)
    },
    // 获取单个经销商管辖的所有用户列表
    async fetchSelectOneDealerUserJurisdictionAllAppletUserList({ commit, getters }, params) {
      const { selectOneDealerUserJurisdictionAllAppletUserList } = getters.getHttps
      const { data } = await selectOneDealerUserJurisdictionAllAppletUserList(params)
      return setStoreApiDate(data, commit)
    },
    // 获取单个经销商绑定的所有设备列表
    async fetchSelectOneDealerUserBindingAllDeviceList({ commit, getters }, params) {
      const { selectOneDealerUserBindingAllDeviceList } = getters.getHttps
      const { data } = await selectOneDealerUserBindingAllDeviceList(params)
      return setStoreApiDate(data, commit)
    },

    /* --- 记录 */
    // 使用
    async fetchSelectDealerAppletUserDeviceUseCountRecordPageList({ commit, getters }, params) {
      const { selectDealerAppletUserDeviceUseCountRecordPageList } = getters.getHttps
      const { data } = await selectDealerAppletUserDeviceUseCountRecordPageList(params)
      return setStoreApiDate(data, commit)
    },
    // 连接
    async fetchSelectDealerAppletUserDeviceConnectionCountRecordPageList({ commit, getters }, params) {
      const { selectDealerAppletUserDeviceConnectionCountRecordPageList } = getters.getHttps
      const { data } = await selectDealerAppletUserDeviceConnectionCountRecordPageList(params)
      return setStoreApiDate(data, commit)
    },

    /* --- 经销商平台 */
    // 查询经销商列表详细信息
    async fetchSelectDealerUserDetails({ commit, getters }, params) {
      const { selectDealerUserDetails } = getters.getHttps
      const { data } = await selectDealerUserDetails(params)
      return setStoreApiDate(data, commit)
    },
    // 修改经销商用户密码
    async fetchUpdateDealerUserPassword({ commit, getters }, params) {
      const { updateDealerUserPassword } = getters.getHttps
      const { data } = await updateDealerUserPassword(params,true)
      return setStoreApiDate(data, commit)
    },
  }
}
